module.exports = __webpack_public_path__ + "static/media/medication-therapy.639b3352.svg";